import React from 'react'

export type BranchAndTagCountData = {branches: number; tags: number}
export type BranchAndTagCount = BranchAndTagCountData | null | undefined

const BranchAndTagCountContext = React.createContext<BranchAndTagCount>(null)

export function useBranchAndTagCount() {
  return React.use(BranchAndTagCountContext)
}

export function BranchAndTagCountProvider({count, children}: React.PropsWithChildren<{count: BranchAndTagCount}>) {
  return <BranchAndTagCountContext value={count}>{children}</BranchAndTagCountContext>
}
